import { Subscription } from 'rxjs';
import { UiService } from '@services/ui.service';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';

import { environment } from '../../../environments/environment';
import { AuthService } from '@services/auth.service';
import { AuthUser } from '@classes/auth/auth-user';
import { NavLink } from '@classes/nav-link';
import { NavService } from '@services/nav.service';
import { RoleName } from '@enums/role-name.enum';
import { MatDialog } from '@angular/material/dialog';
import { SitesService } from '@services/sites.service';
import { DialogChooseDropdownComponent } from '@components/dialog-choose-dropdown/dialog-choose-dropdown.component';
import { Client } from '@classes/client';
import { Site } from '@classes/site';
import { ClientsService } from '@services/clients.service';
import { UsersService } from '@services/users.service';
import { FormControl } from '@angular/forms';
import { User } from '@classes/user/user';
import { debug } from 'console';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
})
export class MainHeaderComponent implements OnInit, OnChanges {
  @Input() isAuth: boolean;
  @Output() sidenavToggle = new EventEmitter<void>();
  appName: string = environment.appName;
  appVersion: string = environment.version;
  user: AuthUser;
  headerNavLinks: NavLink[];

  isRouteLoading: boolean;
  isDispatcher: boolean;
  canSelectClient: boolean;

  clients: Client[] = [];
  clientControl = new FormControl();
  currentUser: User;

  private subscription = new Subscription();

  constructor(
    private authSrv: AuthService,
    private navSrv: NavService,
    private uiSrv: UiService,
    private dialog: MatDialog,
    private sitesSrv: SitesService,
    private _clientService: ClientsService,
    private _userService: UsersService,
  ) {}

  ngOnInit() {
    this.initSubscriptions();
  }

  private initSubscriptions(): void {
    this.subscription.add(
      this.uiSrv.routeLoadingStateChanged.subscribe((loadingState) => {
        this.isRouteLoading = loadingState;
      }),
    );

    this.clientControl.valueChanges.subscribe((value: string | Client) => {
      if (typeof value === 'string' && value === 'all') {
        this._userService.patchClientAll$().subscribe();
      } else if (typeof value === 'object') {
        this._userService.patchClient$(value).subscribe();
      }
    });
  }

  ngOnChanges(): void {
    if (this.isAuth) {
      this.user = this.authSrv.getUser();
      this.isDispatcher =
        this.user.role.name === RoleName.bizzdev ||
        this.user.role.name === RoleName.super_admin ||
        this.user.role.name === RoleName.admin ||
        this.user.role.name === RoleName.dispatcher;

      this.canSelectClient =
        this.user.role.name === RoleName.bizzdev ||
        this.user.role.name === RoleName.super_admin;

      this.headerNavLinks = this.navSrv.getHeaderNavLinks();

      this._userService.getCurrentUser$().subscribe((user) => {
        this.currentUser = user;
        this._clientService.getList().subscribe((client) => {
          this.clients = client;
          const selectedClient = this.clients.find(
            (client) => client.id === this.currentUser?.clientId,
          );
          if (selectedClient) {
            this.clientControl.setValue(selectedClient);
          } else {
            this.clientControl.setValue('all');
          }
        });
      });
    } else {
      this.user = null;
      this.headerNavLinks = null;
    }
  }

  onToggleSidenav(): void {
    this.sidenavToggle.emit();
  }

  goTocloud() {
    this.uiSrv.loadingStateChanged.next(true);

    this.sitesSrv.getList().subscribe((sites) => {
      this.uiSrv.loadingStateChanged.next(false);
      const dialog = this.dialog.open(DialogChooseDropdownComponent, {
        maxWidth: '500px',
        data: {
          title: 'sitesCloud.dialog.title',
          message: 'sitesCloud.dialog.message',
          label: 'sitesCloud.dialog.label',
          list: sites,
        },
      });
      dialog.afterClosed().subscribe((response) => {
        if (response) {
          if (response.documentUrl) {
            window.open(response.documentUrl, '_blank');
          } else {
            this.uiSrv.showSnackbar(
              "Ce donneur d'ordre ne dispose pas d'URL cloud dans ses paramètres.",
            );
          }
        }
      });
    });
  }

  redirectToRuptela(): void {
    window.open(`https://basic.m-worker.com/`, '_blank');
  }
}
